import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pr-2 text-secondary" }
const _hoisted_2 = {
  key: 1,
  class: "text-subtitle-2"
}
const _hoisted_3 = {
  key: 0,
  class: "text-subtitle-2 text-medium-emphasis"
}
const _hoisted_4 = { class: "text-secondary" }

import { VCombobox } from "vuetify/lib/components/index.mjs";
import { computed, ref } from "vue";
import { useDefaults } from "vuetify";

interface IProps {
    items: any[];
    label: string;
    itemTitle?: string | ((item: any) => string);
    variant?: "clear" | "filled";
}

const comboListMaxWidth = "300px";


export default /*@__PURE__*/_defineComponent({
  __name: 'ossTagsSelector',
  props: /*@__PURE__*/_mergeModels({
    items: {},
    label: {},
    itemTitle: { type: [String, Function] },
    variant: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props_ = __props;
const props = useDefaults(props_, "OssTagsSelector");

const modelValue = _useModel<any>(__props, "modelValue");

const search = ref(null);

// Dynamic component tag
const component = computed(() => {
    return props.variant === "filled" ? "v-combobox-filled" : VCombobox;
});

const selectedTags = computed({
    get: () => modelValue.value,
    set: (tags) => {
        modelValue.value = tags;
    },
});

const remove = (item) => {
    selectedTags.value = selectedTags.value.filter((x) => x.id !== item.id);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (!_ctx.$vuetify.display.mobile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(selectedTags.value.length > 2 && 'overflow: hidden;')
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
          key: _unref(props).variant === 'filled' ? 'v-combobox-filled' : 'v-comboboxx',
          modelValue: selectedTags.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTags).value = $event)),
          "hide-no-data": !search.value,
          items: _unref(props).items,
          "search-input": search.value,
          label: _unref(props).label,
          "item-title": _unref(props).itemTitle,
          "hide-selected": "",
          multiple: "",
          "hide-details": "",
          "single-line": selectedTags.value.length > 2,
          "list-props": { maxWidth: comboListMaxWidth }
        }, {
          selection: _withCtx(({ item, selected, index }) => [
            (item === Object(item) && index < 3)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  color: `${item.raw.color}`,
                  "model-value": selected,
                  variant: item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat',
                  size: "small",
                  density: "compact",
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1),
                    _createVNode(_component_v_icon, {
                      icon: "$close",
                      onClick: ($event: any) => (remove(item.raw)),
                      class: "text-secondary"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["color", "model-value", "variant"]))
              : (index === selectedTags.value.length - 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " + " + _toDisplayString(selectedTags.value.length - 3) + " autre(s)", 1))
                : _createCommentVNode("", true)
          ]),
          item: _withCtx(({ item, props }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              style: {
                        minHeight: '30px',
                        pointerEvents: item.raw.header ? 'none' : 'auto',
                    }
            }), {
              title: _withCtx(() => _cache[1] || (_cache[1] = [])),
              default: _withCtx(() => [
                (item.raw.header)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.raw.header), 1))
                  : (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      color: `${item.raw.color}`,
                      variant: item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat',
                      size: "small",
                      label: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.title) + " " + _toDisplayString(item.raw.count ? " (" + item.raw.count + ")" : ""), 1)
                      ]),
                      _: 2
                    }, 1032, ["color", "variant"]))
              ]),
              _: 2
            }, 1040, ["style"])
          ]),
          _: 1
        }, 8, ["modelValue", "hide-no-data", "items", "search-input", "label", "item-title", "single-line", "list-props"]))
      ], 4))
    : _createCommentVNode("", true)
}
}

})